{
  "securitySettings.title": "忠诚度配置",
  "securitySettings.menuTab.walletApp": "Loyalty Wallet",
  "securitySettings.menuTab.apiKey": "API 密钥",
  "securitySettings.menuTab.rds": "RDS 配置",
  "securitySettings.menuTab.salesData": "销售数据导入",
  "securitySettings.menuTab.productCatalog": "产品目录导入",
  "securitySettings.menuTab.dataLoad": "数据加载",
  "securitySettings.disabledCreateButton.noSiData": "确保 Smart Insight 设置已完成。",
  "securitySettings.error.authentication": "您的用户名或密码不正确。请重试。",
  "securitySettings.error.general.title": "错误",
  "securitySettings.error.general.text": "发生错误，请重试",
  "securitySettings.warning.smartInsightsLinkText": "Smart Insight",
  "securitySettings.warning.smartInsights": "您必须完成 {link} 设置才能创建 API 密钥。",
  "securitySettings.grid.column.admin": "管理员",
  "securitySettings.grid.column.appId": "应用标识",
  "securitySettings.grid.column.description": "描述",
  "securitySettings.grid.column.created": "已创建",
  "securitySettings.grid.column.status": "状态",
  "securitySettings.grid.editTooltip": "编辑",
  "securitySettings.grid.deleteTooltip": "删除",
  "securitySettings.grid.data.activated": "已激活",
  "securitySettings.grid.data.deactivated": "已取消激活",
  "securitySettings.authPopup.accountPasswordField": "账户密码",
  "securitySettings.authPopup.accountPasswordFieldError": "输入账户密码。",
  "securitySettings.authPopup.footerText": "如果您正在使用 SSO，请联系 SAP Emarsys 支持团队。",
  "securitySettings.setup.appId.label": "应用标识",
  "securitySettings.setup.secretKey.label": "密钥",
  "securitySettings.setup.apiKey.label": "API 密钥",
  "securitySettings.setup.description.label": "描述",
  "securitySettings.setup.updateDescription.label": "更新描述",
  "securitySettings.setup.CreateNewSecret.label": "创建密钥",
  "securitySettings.setup.createNewSecret.popup.title": "创建密钥",
  "securitySettings.setup.createNewSecret.popup.content": "为现有应用标识创建密钥。<strong>创建密钥后，您的钱包将被禁用，直到您的网站代码中更新新的密钥。</strong>输入密码以确认您的身份。",
  "securitySettings.setup.activation.label": "激活",
  "securitySettings.setup.backButton": "返回",
  "securitySettings.walletApp.notificationLinkText": "应用标识/密钥",
  "securitySettings.walletApp.notificationHelpLinkText": "了解更多",
  "securitySettings.walletApp.createButton": "创建应用标识/密钥",
  "securitySettings.walletApp.createButton.disabledTooltip.notAccountOwner": "只有账户所有者可以创建应用标识/密钥。",
  "securitySettings.walletApp.authPopup.create.title": "创建应用标识/密钥",
  "securitySettings.walletApp.authPopup.create.content": "输入密码确认身份后，您才能创建应用标识/密钥。",
  "securitySettings.walletApp.authPopup.delete.title": "删除应用标识/密钥",
  "securitySettings.walletApp.authPopup.delete.content": "是否确定要删除此应用标识/密钥？<strong>删除后，您的钱包将被禁用。</strong><br />输入密码确认身份。",
  "securitySettings.walletApp.statusPopup.activate.title": "激活钱包",
  "securitySettings.walletApp.statusPopup.activate.content": "确认您要激活钱包。激活钱包后，钱包将显示在您的网站上。",
  "securitySettings.walletApp.statusPopup.deactivate.title": "取消激活钱包",
  "securitySettings.walletApp.statusPopup.deactivate.content": "确认您要取消激活钱包。取消激活钱包后，钱包将无法在您的网站上使用。",
  "securitySettings.walletApp.setup.title": "创建应用标识/密钥",
  "securitySettings.walletApp.setup.createdSuccessfully": "应用标识/密钥已创建。",
  "securitySettings.walletApp.setup.createdNotification": "记下您的密钥。这是唯一一次显示您的密钥。关闭此窗口后，您将无法再次访问密钥。您必须生成新的密钥。",
  "securitySettings.walletApp.setup.description.tooltip": "输入应用标识的唯一描述。",
  "securitySettings.walletApp.setup.activation.tooltip": "激活或取消激活您的应用标识以更新您网站上的钱包",
  "securitySettings.walletApp.setup.activation.options.activate": "激活钱包",
  "securitySettings.walletApp.setup.activation.options.deactivate": "取消激活钱包",
  "securitySettings.walletApp.setup.deleteContact.label": "取消会员资格",
  "securitySettings.walletApp.setup.deleteContact.tooltip": "如果您希望钱包中的取消会员资格按钮删除会员的所有忠诚度报告数据，则选择此选项。",
  "securitySettings.walletApp.setup.deleteContact.checkboxText": "从报告数据库中删除所有忠诚度数据。",
  "securitySettings.apiKey.notificationLinkText": "忠诚度 API",
  "securitySettings.apiKey.notificationHelpLinkText": "了解更多",
  "securitySettings.apiKey.notificationMessage": "为 {link} 端点创建 API 密钥。启动忠诚度计划后，API 密钥将被启用。如果您使用 SSO，请联系 SAP Emarsys 支持团队以获取 API 密钥。{helpLink}",
  "securitySettings.apiKey.createButton": "创建 API 密钥",
  "securitySettings.apiKey.createButton.disabledTooltip.notAccountOwner": "只有账户所有者才能创建 API 密钥。",
  "securitySettings.apiKey.createButton.disabledTooltip.maxItems": "您不能同时拥有 {maxItems} 个以上 API 密钥。",
  "securitySettings.apiKey.authPopup.create.title": "创建 API 密钥",
  "securitySettings.apiKey.authPopup.create.content": "要创建 API 密钥，请输入密码以确认您的身份。",
  "securitySettings.apiKey.authPopup.delete.title": "删除 API 密钥",
  "securitySettings.apiKey.authPopup.delete.content": "是否确定要删除此 API 密钥？<strong>删除后，API 密钥将被禁用。</strong><br />输入密码确认身份。",
  "securitySettings.apiKey.statusPopup.activate.title": "激活 API 密钥",
  "securitySettings.apiKey.statusPopup.activate.content": "确认您要激活 API 密钥。<strong>激活 API 密钥后，您可以使用忠诚度 API 端点。</strong>",
  "securitySettings.apiKey.statusPopup.deactivate.title": "取消激活 API 密钥",
  "securitySettings.apiKey.statusPopup.deactivate.content": "确认您要取消激活 API 密钥。<strong>取消激活 API 密钥后，您的忠诚度 API 调用将被禁用。<strong>。",
  "securitySettings.apiKey.setup.title": "创建 API 密钥",
  "securitySettings.apiKey.setup.createdSuccessfully": "API 密钥已创建。",
  "securitySettings.apiKey.setup.createdNotification": "记下您的 API 密钥。这是唯一一次显示您的 API 密钥。关闭此窗口后，您将无法再次访问 API 密钥。您必须生成新的密钥。",
  "securitySettings.apiKey.setup.description.tooltip": "输入 API 密钥的唯一描述。",
  "securitySettings.apiKey.setup.activation.tooltip": "取消激活 API 密钥后，使用此密钥对忠诚度 API 的调用将不起作用。",
  "securitySettings.apiKey.setup.activation.options.activate": "激活 API 密钥",
  "securitySettings.apiKey.setup.activation.options.deactivate": "取消激活 API 密钥",
  "securitySettings.apiKey.setup.deleteContact.label": "删除联系人 API",
  "securitySettings.apiKey.setup.deleteContact.tooltip": "如果您希望 {link} API 删除会员的所有忠诚度数据，则选择此选项。",
  "securitySettings.apiKey.setup.deleteContact.tooltipLinkText": "删除",
  "securitySettings.apiKey.setup.deleteContact.checkboxText": "从报告数据库中删除会员的所有忠诚度数据。",
  "securitySettings.rds.createButton": "创建 RDS 凭据",
  "securitySettings.rds.createButton.disabledTooltip.notAccountOwner": "只有账户所有者可以创建 RDS 凭据。",
  "securitySettings.rds.createNotificationMessageLinkText": "此处",
  "securitySettings.rds.createNotificationMessage": "在忠诚度数据库中创建您的 RDS 凭证。与忠诚度数据库的连接可让您构建忠诚度细分。了解有关建立连接和创建忠诚度细分模板的更多信息 {helpLink}。",
  "securitySettings.rds.createdNotificationMessageWithPassword": "您的 RDS 凭证可创建与忠诚度数据库的连接。RDS 可让您构建忠诚度模板细分。了解有关建立连接和创建忠诚度细分模板的更多信息 {helpLink}。",
  "securitySettings.rds.createdNotificationMessageWithoutPassword": "您的 RDS 凭证可创建与忠诚度数据库的连接。RDS 可让您构建忠诚度模板细分。了解有关建立连接和创建忠诚度细分模板的更多信息 {helpLink}。如果您忘记了密码，请联系 SAP Emarsys 支持团队。",
  "securitySettings.rds.createdWarningNotification": "记下您的密码。这是唯一一次显示您的密码。关闭此窗口后，您将无法再次访问您的密码。您必须联系 SAP Emarsys 支持团队。",
  "securitySettings.rds.fields.databaseName": "数据库名称",
  "securitySettings.rds.fields.port": "端口",
  "securitySettings.rds.fields.host": "主机",
  "securitySettings.rds.fields.userName": "用户名",
  "securitySettings.rds.fields.password": "密码",
  "securitySettings.rds.fields.certificate": "CA 证书",
  "securitySettings.rds.authPopup.create.title": "创建 RDS 凭据",
  "securitySettings.rds.authPopup.create.content": "要创建 RDS 凭据，请输入密码以确认您的身份。",
  "securitySettings.salesData.pageTitle": "销售数据导入",
  "securitySettings.salesData.topNotification": "要启用忠诚度销售数据导入，请确保您首先在管理 -> Smart Insight 设置 -> 购买字段下完成销售上线。确保数据已成功上载到 Emarsys。然后，完成此页面上的配置，并激活导入。{link}",
  "securitySettings.salesData.topNotification.linkText": "了解更多",
  "securitySettings.salesData.saveButton": "保存",
  "securitySettings.salesData.selectTheSourceOfSalesData": "选择销售数据的源。",
  "securitySettings.salesData.sourceField.label": "销售数据源",
  "securitySettings.salesData.sourceField.isRequiredError": "销售数据源是必填项。",
  "securitySettings.salesData.sourceField.shopifyPluginOption": "Shopify 插件",
  "securitySettings.salesData.sourceField.shopifyPluginOptionTooltip": "了解有关插件 {link} 的更多信息。",
  "securitySettings.salesData.sourceField.shopifyPluginOptionTooltipLinkText": "此处",
  "securitySettings.salesData.sourceField.csvApiOption": "SFTP/API CSV 上载",
  "securitySettings.salesData.sourceField.csvApiOptionTooltip": "了解有关 SFTP/API CSV 上载和忠诚度必填字段 {link} 的更多信息。",
  "securitySettings.salesData.sourceField.csvApiOptionTooltipLinkText": "此处",
  "securitySettings.salesData.sourceField.streamOnboardingOption": "流上线",
  "securitySettings.salesData.salesField.label": "忠诚度积分销售字段",
  "securitySettings.salesData.salesField.tooltip": "从您的销售数据中选择用于计算积分的字段。",
  "securitySettings.salesData.salesField.priceOption": "价格",
  "securitySettings.salesData.salesField.originalPriceOption": "f_original_price",
  "securitySettings.salesData.salesField.originalPriceOption.tooltip": "如果您使用多种货币或您的销售数据在市场字段下包含多个市场名称，请选择 f_original_price 字段。确保在管理 -> Smart Insight 设置 -> 购买字段下将字段 f_original_price 和 s_original_currency 设置为可过滤。{link}。",
  "securitySettings.salesData.salesField.originalPriceOption.tooltipLinkText": "了解更多",
  "securitySettings.salesData.marketsField.label": "要导入到忠诚度的市场",
  "securitySettings.salesData.marketsField.tooltip": "市场名称需要准确拼写，就像您在市场字段下的销售数据中发送的文本一样。只有这些行才会被导入并计算到忠诚度。确保在管理 -> Smart Insight 设置 -> 购买字段下将字段 s_market 设置为可过滤。",
  "securitySettings.salesData.marketsField.addMarketButton": "添加市场",
  "securitySettings.salesData.marketsField.isRequiredError": "市场是必填字段",
  "securitySettings.salesData.savedSuccessfully": "销售数据设置已保存。",
  "securitySettings.salesData.savedError": "尝试更新设置时出错",
  "securitySettings.salesData.duplicatedNameError": "此名称已在使用中，请选择其他名称。",
  "securitySettings.salesData.startDateImport.label": "购买导入的开始日期",
  "securitySettings.salesData.startDateImport.tooltip": "选择要导入的销售数据中购买的开始日期。忠诚度将根据从此日期开始的购买计算积分。您只能选择最多 30 天前的日期。",
  "securitySettings.salesData.startDateImport.isRequiredError": "要购买导入的开始日期是必填项",
  "securitySettings.salesData.startTimeImport.label": "销售导入的开始时间",
  "securitySettings.salesData.startTimeImport.tooltip": "选择忠诚度应从 Smart Insight 导入销售数据的小时 (CET)。确保在管理 > Smart Insight 设置 > 高级中指定的 Smart Insight 数据加载后两小时对其进行计划。",
  "securitySettings.salesData.activation.label": "激活",
  "securitySettings.salesData.activation.options.activate": "激活销售导入",
  "securitySettings.salesData.activation.options.deactivate": "取消激活销售导入",
  "securitySettings.salesData.planNotLaunched": "您首先需要启动忠诚度计划来设置销售数据导入。{link}。",
  "securitySettings.salesData.planNotLaunched.linkText": "了解更多",
  "securitySettings.productCatalog.pageTitle": "产品数据导入",
  "securitySettings.productCatalog.topNotification": "要启用忠诚度产品数据导入，请确保您首先在管理 -> Smart Insight 设置 -> 产品字段下完成销售上线。确保数据已成功上载到 Emarsys。然后，完成此页面上的配置。保存更改后，导入已启用。{link}。",
  "securitySettings.productCatalog.topNotification.linkText": "了解更多",
  "securitySettings.productCatalog.saveButton": "保存",
  "securitySettings.productCatalog.savedSuccessfully": "产品导入数据设置已保存。",
  "securitySettings.productCatalog.savedError": "尝试更新设置时出错",
  "securitySettings.productCatalog.categoryPathSeparator.label": "选择类别路径分隔符",
  "securitySettings.productCatalog.categoryPathSeparator.tooltip": "选择上载到 Smart Insight 的产品目录中使用的类别分隔符。这些分隔符用于在产品层次结构中定位每个产品。示例：新系列 > 衬衫 -> 女式衬衫。",
  "securitySettings.productCatalog.categoryPathSeparator.isRequiredError": "类别路径分隔符是必填项",
  "securitySettings.productCatalog.startTimeImport.label": "产品数据导入的开始时间",
  "securitySettings.productCatalog.startTimeImport.tooltip": "选择忠诚度应从 Smart Insight 导入产品数据的小时 (CET)。确保在管理 > Smart Insight 设置 > 高级中指定的 Smart Insight 数据加载后两小时对其进行计划。",
  "securitySettings.productCatalog.activation.label": "激活",
  "securitySettings.productCatalog.activation.options.activate": "激活产品导入",
  "securitySettings.productCatalog.activation.options.deactivate": "取消激活产品导入",
  "securitySettings.dataLoad.topNotification": "加载表将显示过去 48 小时内采购和产品目录数据的导入任务。如果您发现任何无法修复的错误，请联系 SAP Emarsys 支持团队。{link}",
  "securitySettings.dataLoad.topNotification.linkText": "了解更多。",
  "securitySettings.dataLoad.table.header.refreshButton": "刷新",
  "securitySettings.dataLoad.table.header.taskType": "任务类型",
  "securitySettings.dataLoad.table.header.status": "状态",
  "securitySettings.dataLoad.table.header.messages": "消息",
  "securitySettings.dataLoad.table.header.date": "日期",
  "securitySettings.dataLoad.table.header.date.tooltip": "日期根据账户中配置的时区显示。",
  "securitySettings.dataLoad.table.taskType.dailyPurchaseImport": "每日购买导入",
  "securitySettings.dataLoad.table.taskType.dailyCatalogImport": "每日目录导入",
  "securitySettings.dataLoad.table.taskType.dailyPurchaseCopy": "每日购买复制",
  "securitySettings.dataLoad.table.taskStatus.new": "新",
  "securitySettings.dataLoad.table.taskStatus.published": "已发布",
  "securitySettings.dataLoad.table.taskStatus.running": "运行中",
  "securitySettings.dataLoad.table.taskStatus.done": "已完成",
  "securitySettings.dataLoad.table.taskStatus.failed": "已失败",
  "securitySettings.dataLoad.table.taskMessage.doneHasResults": "成功导入新数据。",
  "securitySettings.dataLoad.table.taskMessage.doneNoResults": "没有要导入的新数据。",
  "securitySettings.dataLoad.table.taskMessage.doneCopyPurchase": "数据已成功复制。",
  "securitySettings.dataLoad.table.taskMessage.failedCopyPurchase": "销售数据无法复制到忠诚度，请联系支持人员。",
  "securitySettings.walletApp.notificationMessage": "创建您的会员钱包 {link}。每个钱包都需要单独的凭证。钱包将在您的会员计划启动后激活。如果您使用 SSO，请联系 SAP Emarsys 支持团队获取钱包凭据。{helpLink}"
}
